import React, { ReactNode } from 'react';

import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

import styles from './AlertBox.module.scss';

import useKeyPress from '../../../hooks/useKeyPress';

interface AlertBoxProps {
  display: boolean;
  handleClose?: () => void;
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  hideCloseButton?: boolean;
  testId?: string;
}

function AlertBoxInternal({
  handleClose,
  children,
  className,
  title,
  hideCloseButton,
  testId = 'alert-box',
}: Omit<AlertBoxProps, 'display'>) {
  useKeyPress('Escape', handleClose);

  const showHeader = title || (handleClose && !hideCloseButton);

  return (
    <Dialog maxWidth={false} onClose={handleClose} disableScrollLock open>
      {showHeader && (
        <div className={styles.modalHeader}>
          {title && (
            <DialogTitle>
              <Typography variant="h6" component="div">
                {title}
              </Typography>
            </DialogTitle>
          )}

          {handleClose && !hideCloseButton && (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              className={styles.modalHeader__closeButton}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <Close />
            </IconButton>
          )}
        </div>
      )}
      <DialogContent className={className}>
        <div data-testid={testId}>{children}</div>
      </DialogContent>
    </Dialog>
  );
}

function AlertBox({ display, ...rest }: AlertBoxProps) {
  if (display) {
    return <AlertBoxInternal {...rest} />;
  }

  return null;
}

export default AlertBox;
